import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import {  Row } from "reactstrap";
import { TextArea } from "./../../components/writting_essay/textarea";

let answers;
let first_call = true;
const WritingQuestion = ({
  data,
  isReview,
}) => {
  let [wordsCounter, setWordsCount] = useState(
    data.answers
      ? data.answers.replace(/[\n]/g, " ").trim().split(" ").length
      : 0
  );

  if (data.completed_at) {
    isReview = true;
  }

  if (data && data.answers && data.completed_at === null && first_call) {
    first_call = false;
    answers = data.answers;
  }

  let words_count, written_text;

  const textarea_change = (e) => {
    written_text = e.target.value;
    answers = written_text;
    words_count = written_text.replace(/[\n]/g, " ").trim().split(" ").length;
    if (!written_text) {
      words_count = 0;
    }
    setWordsCount(words_count);
  };
  const handleCopyPaste = (e) => {
    if (data && !data.allow_copy_paste) {
      e.preventDefault();
    }
  };




  return (
    <>
      <Row className="bg-white py-2 px-1 g-0">
        <TextArea
          defaultValue={data.completed_at === null ? data.answers : null}
          onCopy={handleCopyPaste}
          onPaste={handleCopyPaste}
          value={isReview ? data.answers : null}
          onchange={textarea_change}
          data-tc="writitng-text"
        />
      <p className=" quiz-bottom-border"></p>
      </Row>
      <Row className="bg-white px-1 g-0">
        <span className="text-muted"> Words: {wordsCounter} words </span>
      </Row>
    </>
  );
};

export default WritingQuestion;
